import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createStaticKey,
  deleteStaticKey,
  getStaticKeys,
  updateStaticKey,
} from "../../../../services/api/instances/staticTokenApi/methods";
import type { StaticKeyRequestType } from "../../../../services/api/instances/staticTokenApi/types";
import type { RootState } from "../../../../services/redux/types";
import { setTokens } from "./slice";
import { getError } from "../../../../services/lib/getError";

export const getAllStaticTokens = createAsyncThunk(
  "staticToken/getAllStaticTokens",
  async (_, { rejectWithValue }) => {
    try {
      return await getStaticKeys();
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const createStaticTokenAction = createAsyncThunk(
  "staticToken/createStaticToken",
  async (token: string, { rejectWithValue }) => {
    try {
      const tokenLifeCycle = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1),
      );
      const postObj = {
        static_key: token,
        valid_till: tokenLifeCycle,
      };
      return await createStaticKey(postObj);
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const updateStaticTokenAction = createAsyncThunk(
  "staticToken/updateStaticToken",
  async (
    body: { postObj: StaticKeyRequestType; id: number },
    { rejectWithValue },
  ) => {
    try {
      const { postObj, id } = body;
      return await updateStaticKey(postObj, id);
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const deleteStaticTokenAction = createAsyncThunk(
  "staticToken/deleteStaticToken",
  async (id: number, ThunkApi) => {
    try {
      const { tokens } = (ThunkApi.getState() as RootState).staticTokenState;
      const filteredTokens = tokens?.filter((token) => token?.id !== id);

      ThunkApi.dispatch(setTokens(filteredTokens));

      return await deleteStaticKey(id);
    } catch (e: unknown) {
      const message = getError(e);
      return ThunkApi.rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);
